import React from 'react';
import Lottie from 'lottie-react';
import loadingAnimation from './Animations/load.json';

const styles = {
  loadingContainer: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
    zIndex: 9999,
  },
  lottie: {
    width: '200px',
    height: '200px',
    display: 'flex',  // Added to ensure Lottie container is flex
    alignItems: 'center',  // Center Lottie content vertically
    justifyContent: 'center',  // Center Lottie content horizontally
  },
  text: {
    marginTop: '20px',
    fontSize: '32px',
    fontWeight: '800',
    color: '#1798C2',
    fontFamily: 'Poppins, sans-serif',
    textAlign: 'center',  
  },
};

const Loading = () => {
  return (
    <div style={styles.loadingContainer}>
      <Lottie 
        animationData={loadingAnimation} 
        style={styles.lottie}
      />
      <div style={styles.text}>Explore. Experience. Evolve....</div>
    </div>
  );
};

export default Loading;